module.exports = __webpack_public_path__ + "static/media/freelancer-image-solutions.5b534b34.webp";